import {
  MANUFAC_MATERIAL_ALL,
  MANUFAC_MATERIAL_GET,
  MANUFAC_MATERIAL_DELETE,
  MANUFAC_MATERIAL_PUT,
  MANUFAC_MATERIAL_POST,
  MANUFAC_MATERIAL_LOADING,
  MANUFAC_MATERIAL_ERROR,
} from '../../actions/types';

const initialState = {
  manufactuirngMaterial: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function ManufacturingMaterialReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case MANUFAC_MATERIAL_LOADING:
      return { isLoading: true, isCompleted: true };
    case MANUFAC_MATERIAL_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case MANUFAC_MATERIAL_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MANUFAC_MATERIAL_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MANUFAC_MATERIAL_POST:
      return { isLoading: false, isCompleted: true };
    case MANUFAC_MATERIAL_PUT:
      return { isLoading: false, isCompleted: true };
    case MANUFAC_MATERIAL_DELETE:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
